import Page from 'flarum/components/Page';
import AboutHeader from '../../components/AboutContent/AboutHeader';

const partners = [
  {
    name: "V17 Development",
    url: "https://www.v17.dev/",
    logo: "https://v17.dev/wp-content/uploads/2020/03/logo.svg",
    type: "Sponsor"
  },
  {
    name: "Mexter",
    url: "https://mexter.nl/",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417044-432331-mexter-icon.svg",
    type: "Sponsor"
  },
  {
    name: "Librus",
    url: "https://librus.nl/",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620418656-530896-librus-proef-220x.png",
    type: "Sponsor"
  },
  {
    name: "Flarum",
    url: "https://flarum.org/",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417203-354676-flarum.svg",
    type: "Community software"
  },
  {
    name: "OfferZen",
    url: "https://www.offerzen.com/nl",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-04-08/1617876732-153369-5e8b2a05b52eaac5238ca6d8-offerzen-logo-white.svg",
    invert: true,
    type: "Developer Job Platform"
  },
  {
    name: "Shieldy",
    url: "https://shieldy.pro/",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-06-02/1622672539-263060-logo-shieldy.svg",
    type: "Partner"
  },
  {
    name: "DigitalOcean",
    url: "https://www.devnl.nl/outlink/digitalocean",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417172-786602-digitalocean-2-1.svg",
    type: "Cloud server"
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/devnl",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417228-493814-linkedin.svg",
    type: "Social Media"
  },
  {
    name: "Twitter",
    url: "https://twitter.com/devnlbe",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417117-556655-twitter-logo-at-logotypus.svg",
    type: "Social Media"
  },
  {
    name: "AWS",
    url: "https://aws.amazon.com/",
    logo: "https://s3.eu-central-1.amazonaws.com/uploads.devnl.nl/2021-05-07/1620417150-310488-aws-2.svg",
    type: "S3 Bucket",
    smaller: true
  }
];

export default class PartnersPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Send history push
    app.history.push('partnersPage');
    
    this.bodyClass = 'App--AboutPage';

    app.setTitle("Partners van DevNL");
  }

  view() {
    return (
      <div className={"Site-AboutPage"}>
        <div className={"container"}>
          <AboutHeader selected={"partners"} />

          <div className={"content-box content-padding"}>
            <p>Chúng tôi đã tập hợp các đối tác chuyên nghiệp xung quanh mình, những người mà chúng tôi cùng làm việc vì một cộng đồng gần gũi hơn nữa. Đồng thời truy cập các trang web của một trong những đối tác của chúng tôi.</p>
          </div>

          <ul className={"About-partner-list"}>
            {partners.map(partner => (
              <li>
                <a href={`${partner.url}?utm_source=devnl`} target={"_blank"} className={"content-box has-hover"}>
                  <div className={`partner-logo${partner.invert ? " invert" : ""}${partner.smaller ? " logo-smaller" : ""}`}>
                    <img src={partner.logo} />
                  </div>
                  <span className={"partner-name"}>{partner.name}</span>
                  <span className={"partner-type"}>{partner.type}</span>
                </a>
              </li>
            ))}
          </ul>

          <div className={"content-box content-padding"}>
          <p>Bạn có muốn bắt đầu hợp tác với KhatVongSong không? Vui lòng liên hệ với chúng tôi: <a href={"mailto:info@khatvongsong"}>info@khatvongsong</a></p>          </div>
        </div>
      </div>
    )
  }
}